import React from "react";
import Bed from "@icons-rf/properties-item/bed.svg?react";
import Bath from "@icons-rf/properties-item/bath.svg?react";
import HalfBath from "@icons-rf/properties-item/toiled.svg?react";
import Card from "@icons-rf/properties-item/carro.svg?react";
import Level from "@icons-rf/properties-item/agua.svg?react";
import Casa2 from "@icons-rf/properties-item/casa2.svg?react";
import Medida from "@icons-rf/properties-item/medida.svg?react";
import Price1 from "@icons-rf/price-1.icon.svg?react";
import MxIcons from "@rf-l1/MxIcons";
import MxTypography from "@rf-l1/MxTypography";
import { Tooltip } from "@mui/material";
import { C_REALESTATE_TYPES_PROJECT } from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { styled } from "@mui/system";

interface I_HeaderColumnProject {
  realestateId: number;
  show: {
    name: boolean;
    bedrooms: boolean;
    bathrooms: boolean;
    parking_spots: boolean;
    sqm_construction: boolean;
    sqm_land: boolean;
    price: boolean;
    floor_level: boolean;
    halfBathrooms: boolean;
  };
}
function HeaderColumnProject(props: I_HeaderColumnProject) {
  const HeaderColumnObject = [
    {
      label: "#",
      icon: null,
      size: "11%",
      show: true
    },
    {
      label: "Nombre",
      icon: null,
      size: "11%",
      show: props.show.name
    },
    {
      label: "Hab.",
      icon: (
        <Tooltip title="Habitaciones">
          <MxIcons size={16}>
            <Bed />
          </MxIcons>
        </Tooltip>
      ),
      size: "7%",
      show: props.show.bedrooms
    },
    {
      label: "Baños",
      icon: (
        <Tooltip title="Baños">
          <MxIcons size={16}>
            <Bath />
          </MxIcons>
        </Tooltip>
      ),
      size: "7%",
      show: props.show.bathrooms
    },
    {
      label: "½ Baños",
      icon: (
        <Tooltip title="½ Baños">
          <MxIcons size={16}>
            <HalfBath />
          </MxIcons>
        </Tooltip>
      ),
      size: "7%",
      show: props.show.halfBathrooms
    },
    {
      label: "Parq.",
      icon: (
        <Tooltip title="Parqueos">
          <MxIcons size={16}>
            <Card />
          </MxIcons>
        </Tooltip>
      ),
      size: "7%",
      show: props.show.parking_spots
    },
    {
      label: "Nivel.",
      icon: (
        <Tooltip title="Nivel">
          <MxIcons size={16}>
            <Level />
          </MxIcons>
        </Tooltip>
      ),
      size: "7%",
      show: props.show.floor_level
    },
    {
      label: "M² Solar.",
      icon: (
        <Tooltip title="M² Solar">
          <MxIcons size={16}>
            <Casa2 />
          </MxIcons>
        </Tooltip>
      ),
      size: "8%",
      show: props.show.sqm_land
    },
    {
      label: "M² Const.",
      icon: (
        <Tooltip title="M² Construcción">
          <MxIcons size={16}>
            <Medida />
          </MxIcons>
        </Tooltip>
      ),
      size: "8%",
      show: props.show.sqm_construction
    },
    {
      label: "Precio",
      icon: (
        <Tooltip title="Precio">
          <MxIcons size={16}>
            <Price1 />
          </MxIcons>
        </Tooltip>
      ),
      size: "35%",
      show: props.show.price
    }
  ];

  return (
    <HeaderColumn realestateId={props.realestateId}>
      {HeaderColumnObject.map((item, index) => {
        return (
          <Section
            key={index}
            style={{
              display: item.show ? "flex" : "none"
            }}
          >
            {item.icon}
            {(index === 1 || index === 0) && (
              <MxTypography variant="caption" fontWeight={700}>
                {item.label}
              </MxTypography>
            )}
          </Section>
        );
      })}
    </HeaderColumn>
  );
}

export default HeaderColumnProject;

const HeaderColumn = styled("div")<{ realestateId: number }>(
  ({ theme, realestateId }) => ({
    width: "100%",
    display: "grid",
    height: "40px",
    backgroundColor: theme.palette.grey[200],
    gridTemplateColumns: (() => {
      if (realestateId === C_REALESTATE_TYPES_PROJECT.LAND.id) {
        return "0.5fr repeat(3, 0.9fr)";
      } else if (
        realestateId === C_REALESTATE_TYPES_PROJECT.COMERCIAL_SITE.id ||
        realestateId === C_REALESTATE_TYPES_PROJECT.INDUSTRIAL_SITE.id ||
        realestateId === C_REALESTATE_TYPES_PROJECT.HOUSE.id
      ) {
        return "0.45fr 0.8fr repeat(4, 0.25fr) repeat(2, 0.5fr) ";
      } else if (realestateId === C_REALESTATE_TYPES_PROJECT.APARTMENT.id) {
        return "0.45fr 0.8fr repeat(5, 0.25fr)  repeat(2, 0.5fr)";
      }
      return "0.45fr 0.8fr repeat(5, 0.25fr)  repeat(2, 0.5fr)";
    })(),
    "& > div": {
      borderLeft: `1px solid ${theme.palette.primary.main}`,
      borderBottom: `1px solid ${theme.palette.primary.main}`,
      padding: "0 5px",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    "& > div:first-of-type": {
      borderLeft: "none",
      padding: "0 20px"
    }
  })
);

const Section = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  height: "40px",
  color: theme.palette.primary.main,
  fontFamily: "Gotham, sans-serif",
  fontWeight: 700,
  fontSize: "11px",
  gap: "5px",
  "& svg": {
    flexShrink: 0
  }
}));
